import { render } from "./SwaggerComponent.vue?vue&type=template&id=051b930b&scoped=true"
import script from "./SwaggerComponent.vue?vue&type=script&lang=js"
export * from "./SwaggerComponent.vue?vue&type=script&lang=js"

import "./SwaggerComponent.vue?vue&type=style&index=0&id=051b930b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-051b930b"]])

export default __exports__